import { v4 as uuidv4 } from 'uuid';
export const headerHeight = 40;
export const rightPanelWidth = 260;
export const rightPanelExpandedWidth = 320;

export const leftNavBarWidth = 80;
export const navBarWidth = 320;

export const sideBarWidth = 206;
export const sideBarExpandedWidth = 300;

export const formFooterHeight = 52;
export const statBarHeight = 90;

// TODO: Increase to common resolution 1920px
export const fullHDScreenWidth = '1920px';
export const fullHDFormWidth = '1100px';

export const userListContainerWidth = '360px';

export enum FormLabelWidth {
  XSMALL = '94px',
  DEFAULT = '160px',
  MEDIUM = '260px',
  LARGE = '360px',
}

export const clientId = uuidv4();

export const TAG_RESERVED = 'RESERVED';

export const OVERFILL_METHOD_5 = '5';

export const TAG_GAP = 'GAP';
